var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/306bac20478f428e87abebf40b2788be.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6841cb2ca456c6afbd48fbe20fe7a7b1.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7fbb06c55876b1980c1647b03fd7a33a.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/892557b71fe804b35b705dd4e7df3e53.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    